var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container',[_c('d2-demo-article')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }